import React, { Component, useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";

import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";
import { Button, CircularProgress, Divider, FormHelperText, Grid, IconButton, InputAdornment, makeStyles, Paper, TextField, Typography } from "@material-ui/core";
import { AccountCircle, Alarm, Instagram, LinkedIn, Lock, Twitter, Visibility, VisibilityOff } from "@material-ui/icons";
import { useTranslation, withTranslation } from "react-i18next";
import moment from "moment";

const INITIAL_STATE = {
  email: "",
  password: "",
  error: null,
};

const SignInFormBase = (props) => {
  const { firebase } = props;

  const history = useHistory();
  /*constructor(props) {
    super(props);
    console.log("inicio", props);
    this.state = { ...INITIAL_STATE };
  }*/

  const [state, setState] = useState(INITIAL_STATE);
  const [loading, setLoading] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);

  const { email, password, error } = state;
  const isInvalid = password === "" || email === "";
  const { t } = useTranslation();

  /*useEffect(() => {
    !!firebase.currentUser() && history.push(ROUTES.HOME);
  }, [firebase.currentUser()]);*/
  useEffect(() => {
    firebase.auth.onAuthStateChanged((authUser) => {
      setTimeout(() => {
        if (!!authUser) {
          firebase
            .user(authUser.uid)
            .once("value")
            .then((snap) => {
              const OnsiteTrainingInfo = snap.val()?.sgpfc?.onSiteTrainings?.forms;
              let t = !!OnsiteTrainingInfo
                ? Object.keys(OnsiteTrainingInfo)
                    .map((k) =>
                      moment().isBetween(moment(OnsiteTrainingInfo[k].startDay, "DD/MM/YYYY"), moment(OnsiteTrainingInfo[k].endDay, "DD/MM/YYYY"), undefined, "[]")
                        ? !OnsiteTrainingInfo[k].isReviewed
                        : false
                    )
                    .reduce((pre, cur) => pre || cur, false)
                : false;
              //console.log("tiene pendientes", t);
              t ? history.push(ROUTES.ONSITE_TRAINING) : history.push(ROUTES.HOME);
            });
        }
      }, 500);
    });
  }, []);

  const onSubmit = (event) => {
    const { email, password } = state;
    setLoading(true);
    setState({ ...state, error: null });
    firebase
      .doSignInWithEmailAndPassword(email, password)
      .then(() => {
        setState({ ...INITIAL_STATE });
        //history.push(ROUTES.HOME);
      })
      .catch((error) => {
        setState({ ...state, error });
        setLoading(false);
      });

    event.preventDefault();
  };

  const onChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  return (
    <form onSubmit={onSubmit} error={error} helper>
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        spacing={4}
        // style={{ margin: 0, padding: 32 }}
      >
        <Grid item xs={12} container>
          <TextField
            id="email"
            variant="outlined"
            error={error}
            name="email"
            value={email.toLowerCase().trim()}
            onChange={onChange}
            onBlur={onChange}
            type="text"
            label={t("email")}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle color="primary" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} container>
          <TextField
            id="password"
            variant="outlined"
            name="password"
            error={error}
            value={password}
            onChange={onChange}
            type={viewPassword ? "text" : "password"}
            label={t("password")}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock color="primary" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => {
                      setViewPassword(!viewPassword);
                    }}
                    onMouseDown={(event) => {
                      event.preventDefault();
                    }}
                  >
                    {viewPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        {error && (
          <Grid item xs={12}>
            <FormHelperText id="my-helper-text">{t("auth." + error.code)}</FormHelperText>
          </Grid>
        )}

        <Grid container item xs={12} justify="center" alignItems="center">
          {loading ? (
            <CircularProgress />
          ) : (
            <Button
              fullWidth
              variant="contained"
              disabled={isInvalid}
              color="secondary"
              //style={{ color: red[500] }}
              type="submit"
            >
              {t("login")}
            </Button>
          )}
          <Button style={{ marginTop: 8 }} onClick={() => history.push(ROUTES.PASSWORD_FORGET)} fullWidth>
            {t("passwordForgot")}
          </Button>
        </Grid>
        <Grid item xs={9} style={{ width: "100%", paddingTop: 8, paddingBottom: 8 }}>
          <Divider />
        </Grid>

        <Grid container direction="row" justify="center" alignItems="center" style={{ width: "100%" }}>
          <Grid item container xs={3} justify="center" alignItems="center">
            <IconButton color="secondary" onClick={() => window.open("https://twitter.com/BexenCardio", "_blank")}>
              <Twitter fontSize="large" />
            </IconButton>
          </Grid>
          <Grid item container xs={3} justify="center" alignItems="center">
            <IconButton color="secondary" onClick={() => window.open("https://www.instagram.com/bexencardio/", "_blank")}>
              <Instagram fontSize="large" />
            </IconButton>
          </Grid>
          <Grid item container xs={3} justify="center" alignItems="center">
            <IconButton color="secondary" onClick={() => window.open("https://www.linkedin.com/company/bexen-cardio/", "_blank")}>
              <LinkedIn fontSize="large" />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

const SignInForm = withFirebase(SignInFormBase);

export default SignInForm;
